import { IMPERSONATION_LOCAL_STORAGE_KEY } from "@olivahealth/constants";
import UserRole from "@olivahealth/business/src/Core/domain/value-objects/UserRole";

export function isConnectedUserImpersonator(): boolean {
  const storage = localStorage.getItem(IMPERSONATION_LOCAL_STORAGE_KEY);

  if (!storage) {
    return false;
  }

  const { impersonatorId: storageImpersonatorId } = JSON.parse(storage);

  return Boolean(storageImpersonatorId);
}

export function getImpersonatorRoles(): Array<UserRole> {
  const storage = localStorage.getItem(IMPERSONATION_LOCAL_STORAGE_KEY);

  if (!storage) {
    return [];
  }

  const { impersonatorRoles } = JSON.parse(storage);

  return (impersonatorRoles || []) as Array<UserRole>;
}
